export default __webpack_public_path__ + "d6e7b33d67058ef5c571b2d94fc4cdf0.svg";